import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { Segment } from '../../../services/analytics-services/segment';
import Global from '../../../store/global-selectors';
import { EXPERIMENT_VIEWED } from '../../../constants/analytics-events';
import { ACCESS_LEVELS, useRequiresRateShopperAccessLevel } from '../../use-has-rate-shopper-access-level';

export const GROW_742 = 'GROW_742';

export const VARIATIONS = {
  ...ACCESS_LEVELS,
  NONE: 'NONE',
};

const getVariationAsHighestAccessLevel = (hasPremiumAccess, hasFreemiumAccess) => {
  if (hasPremiumAccess) return VARIATIONS.PREMIUM;
  if (hasFreemiumAccess) return VARIATIONS.FREEMIUM;
  return VARIATIONS.NONE;
};

/**
 * Rolling out Freemium Rate Shopper to existing users.
 * Eligibility: US/CA region and Gold, Platinum or Enterprise Plan.
 * @param {boolean} areFeatureFlagsReady featureFlagService.areFeatureFlagsReady()
 * @returns {void}
 */
export const useTrackGrow742Experiment = (areFeatureFlagsReady) => {
  const hasTracked = useRef(false);
  const sellerId = useSelector(Global.selectSellerSellerId)?.toString();
  const userId = useSelector(Global.selectUserCurrentUserId);

  const hasPremiumAccess = useRequiresRateShopperAccessLevel(ACCESS_LEVELS.PREMIUM);
  const hasFreemiumAccess = useRequiresRateShopperAccessLevel(ACCESS_LEVELS.FREEMIUM);

  const variation = getVariationAsHighestAccessLevel(hasPremiumAccess, hasFreemiumAccess);

  // break
  if (!areFeatureFlagsReady || hasTracked.current) {
    return;
  }

  // track the experiment
  Segment.trackEvent(EXPERIMENT_VIEWED, {
    experiment_id: GROW_742,
    group_variation: variation,
    seller_id: sellerId,
    user_id: userId,
    enrollment_date: new Date(),
  });

  hasTracked.current = true;
};
